import { gae, gaeApp, gaeUserNavigate, gaPageView } from '../helpers/Analytics';

export function gaeList(action, label, user) {
  gae('LIST', action, label, undefined, !user);
}

export function gaClickOnDocType(type, id) {
  gaeApp('CLICK_ON_DOCUMENT_ITEM', type, id);
}

export function gaNavigateTo(to) {
  gaeUserNavigate(to);
}

export function gaNavigateBackToList() {
  gaeUserNavigate('Back to List');
}

export function gaNavigateBackToHome() {
  gaeUserNavigate('Back to Home');
}

export function gaListPageView() {
  gaPageView('List');
}

export function gaPropsToGAEvent(props) {}
